import { graphql } from "@/lib/gql/__generated__/gql";

export const ExistingOptionDefaultUpdate_EditPage_Mutation = graphql(/* GraphQL */ `
	mutation ExistingOptionDefaultUpdate($input: OptionInput!) {
		optionUpdate(input: $input) {
			userErrors
			option {
				id
				hotelID
				optionID
				inSale
				isNotDiscountTarget
				maxStockNum
				soldNumTotal
				maxDailyStockNum
				billingTypeTerm
				billingTypeTarget
				optionType
				price {
					currencyType
					amount
				}
				name
				description
				isNextMorning
				cancelPolicy {
					beforeDays
					chargeRatio
				}
				mainKeyVisual {
					bucket
					key
					region
					mimeType
					fileName
				}
				keyVisuals {
					bucket
					key
					region
					mimeType
					fileName
				}
				saleTypeForPlan
				saleTypeForTerm
				saleStart
				saleEnd
				stayableStart
				stayableEnd
				stayableDayOfTheWeek
				isHolidayStayable
				saleStartBeforeDate
				requiredPrepMillisecond
				maxBuyableNumPerTarget
				minimumBuyableNumPerTarget
				useAsSubOption
				multiSubOptionSelectable
				subOptions {
					subOptionID
					name
					startAt
					endAt
					isNextMorning
					memo
					maxDailyStockNum
					isShowTimeSchedule
				}
			}
		}
	}
`);
